// servicesData.js
const servicesData = {
  // Naturopatia Alimentaria
  "perdida-peso": {
    sidebarLinks: [
      { href: "/naturopatia-alimentaria/perdida-peso", label: "Programas para la pérdida de peso", active: true },
      { href: "/naturopatia-alimentaria/mantenimiento", label: "Mantenimiento" },
      { href: "/naturopatia-alimentaria/soporte-online", label: "Soporte Online" }
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      link: "/assets/images/client/brochure.jpg",
      title: "Descargar folleto solidario",
      subtitle: "Fundacion TAS, 1Kg perdido = 1€ donado",
    },
    bannerData: {
      titleLine1: "Llama a nuestros asesores para",
      highlightText: "consulta gratuita",
      titleLine2: "en nutrición",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "Contáctanos en WhatsApp",
      buttonLink:
        "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con+vosotros&type=phone_number&app_absent=0",
    },
    // Tailored content for "pérdida de peso"
    featuredImage: "/assets/images/single-img-5.png",
    introText:
      "¿Buscas perder esos kilos de más? Nuestro programa de pérdida de peso se basa en una alimentación equilibrada y un plan de ejercicio personalizado.",
    specializationTitle: "Nutrición para Bajar de Peso",
    specializationText:
      "Encuentra el equilibrio que necesitas a través de un acompañamiento profesional y adaptado a tus necesidades.",
    leftColumnImage: "/assets/images/bg-image/col-bgimage-3.png",
    rightColumnContent: {
      title: "Transforma tu vida",
      descriptionBefore: "Te acompañamos a lograr un estilo de vida que promueva",
      highlightText: "la pérdida de peso saludable",
      descriptionAfter:
        "y el mantenimiento de los resultados a largo plazo.",
      list1: ["Tabla de alimentación balanceada", "Adaptada a alérgias, intoleracias y condicón"],
      list2: ["Segumiento semanal", "Anexo de intercambios de alimentos"],
      subTitle: "Lo que obtendrás con nuestro programa de pérdida de peso",
      subDescription:
        "Controla tus porciones, aprende a leer etiquetas, adopta hábitos sostenibles y alcanza la meta que siempre has deseado.",
    },
    counters: [
      {
        value: 7,
        title: "Ideas innovadoras",
        description: "Nuestra metodología se basa en 7 ips para asegurar la pérdida de peso",
      },
      {
        value: 1020,
        suffix: "+",
        title: "Programas dietéticos realizados",
        description: "Más de 8 años siendo tu referente en nutrición y bienestar.",
      },
    ],
  },

  "mantenimiento": {
    sidebarLinks: [
      { href: "/naturopatia-alimentaria/perdida-peso", label: "Programas para la pérdida de peso" },
      { href: "/naturopatia-alimentaria/mantenimiento", label: "Mantenimiento", active: true },
      { href: "/naturopatia-alimentaria/soporte-online", label: "Soporte Online" }
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Archivo PDF con más información",
      link: "",
    },
    bannerData: {
      titleLine1: "Llama a nuestros asesores para",
      highlightText: "consulta gratuita",
      titleLine2: "en nutrición",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "Contáctanos en WhatsApp",
      buttonLink:
        "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con&type=phone_number&app_absent=0",
    },
    // Tailored content for "mantenimiento"
    featuredImage: "/assets/images/single-img-4.jpg",
    introText:
      "Has logrado tu peso ideal, pero mantenerlo también es un desafío. Nuestros planes de mantenimiento te ayudarán a conservar tus resultados.",
    specializationTitle: "Nutrición para Mantenerte",
    specializationText:
      "Asegúrate de nutrir tu cuerpo y mantener un estilo de vida equilibrado con el apoyo de nuestros expertos.",
    leftColumnImage: "/assets/images/bg-image/col-bgimage-3.png",
    rightColumnContent: {
      title: "Sostén tus Logros",
      descriptionBefore: "Evita el efecto rebote y sostén",
      highlightText: "tu peso ideal",
      descriptionAfter:
        "disfrutando de una gran variedad de alimentos nutritivos y balanceados.",
      list1: ["Modelo versátil para elección de comidas", "Anexi intercambio de alimentos"],
      list2: ["Adaptada a alergias, patalogías, intolerancias y condición", "Seguimientos más extendidos en el tiempo para trabajar la autonomía"],
      subTitle: "Cómo te ayudamos a mantener tu peso",
      subDescription:
        "Te enseñamos a equilibrar macro y micronutrientes, monitorear porciones y combinar tus alimentos favoritos con hábitos saludables.",
    },
    counters: [
      {
        value: 2000,
        suffix: "+",
        title: "Clientes satisfechos",
        description: "Mantienen su peso exitosamente con nuestro acompañamiento.",
      },
      {
        value: 8,
        title: "Años de experiencia",
        description: "Ayudando a consolidar hábitos alimenticios positivos.",
      },
    ],
  },

  "soporte-online": {
    sidebarLinks: [
      { href: "/naturopatia-alimentaria/perdida-peso", label: "Programas para la pérdida de peso" },
      { href: "/naturopatia-alimentaria/mantenimiento", label: "Mantenimiento" },
      { href: "/naturopatia-alimentaria/soporte-online", label: "Soporte Online", active: true }
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Archivo PDF con más información",
      link: "",
    },
    bannerData: {
      titleLine1: "Contáctanos para tu",
      highlightText: "asesoría virtual",
      titleLine2: "en salud y bienestar",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "Conversa por WhatsApp",
      buttonLink: "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me%27d+gustaria+poder+hablar+con&type=phone_number&app_absent=0",
    },
    featuredImage: "/assets/images/services/online.jpg",
    introText:
      "Accede a nuestros servicios sin importar dónde te encuentres. Ofrecemos consultas de nutrición, entrenamiento y psicología totalmente online.",
    specializationTitle: "Soporte Online Integrado",
    specializationText:
      "Planes personalizados, seguimiento de progreso y contacto permanente con nuestro equipo de forma remota.",
      leftColumnImage: "/assets/images/single-img-5.png",
      rightColumnContent: {
      title: "Siempre a tu Alcance",
      descriptionBefore: "Recibe asesoramiento y motivación a través de",
      highlightText: "videollamadas y chat",
      descriptionAfter: "sin salir de casa, con la misma calidad que en la atención presencial.",
      list1: ["Tabla de alimentación balanceada", "Adaptada a alergias, patologías, intolerancias y condición"],
      list2: ["Seguimiento semanal", "Anexo de intercambio de alimentos"],
      subTitle: "Lo que obtendrás con nuestro soporte online",
      subDescription:
        "Facilidad para conciliar horarios, comodidad y acceso inmediato a la información y recursos de nuestro equipo profesional.",
    },
    counters: [
      {
        value: 150,
        suffix: "+",
        title: "Sesiones online al mes",
        description: "Brindando soporte remoto a clientes de distintas regiones.",
      },
      {
        value: 20,
        title: "En países diferentes",
        description: "Dedicados a atenderte en cualquier lugar y momento.",
      },
    ],
  },

  // Servicios integrates
  "servicios-a-empresas": {
    sidebarLinks: [
      { href: "/otros-servicios/servicios-a-empresas", label: "Servicio a Empresas", active: true  },
      { href: "/otros-servicios/opositores", label: "Opositores" },
      { href: "/otros-servicios/corredores", label: "Corredores"},
      { href: "/otros-servicios/aumento-masa-muscular", label: "Aumento de masa muscular"},
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Archivo PDF con más información",
      link: "",
    },
    bannerData: {
      titleLine1: "Llama a nuestros asesores para",
      highlightText: "consulta gratuita",
      titleLine2: "en bienestar corporativo",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "Contáctanos en WhatsApp",
      buttonLink: "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con&type=phone_number&app_absent=0",
    },
    featuredImage: "/assets/images/single-img-16.jpg",
    introText:
      "Ofrecemos soluciones de menús personalizados para instituciones y empresas, adaptados a las necesidades específicas de cada cliente.",
    specializationTitle: "Menús Personalizados para Empresas",
    specializationText:
      "Diseñamos menús para: Colegios, guarderías y centros de formación; Empresas de caterings; Comedores, restaurantes y bares; Residencias, centros de día y centros de personas con necesidades especiales.",
    leftColumnImage: "/assets/images/bg-image/col-bgimage-3.png",
    rightColumnContent: {
      title: "Nuestros Menús",
      descriptionBefore: "Totalmente personalizadas. Adaptaremos los menús a las necesidades del consumidor, respetando su filosofía de empresa.",
      highlightText: "Certificado de calidad",
      descriptionAfter: "En los menús aparecerá nuestro logo y podrá usarlo en su web y redes sociales.",
      list1: [
        "Realizada y avalada por Conchi Puntas",
        "Graduada en Nutrición Humana y Dietética",
        "Totalmente personalizadas"
      ],
      list2: [],
      subTitle: "Beneficios",
      subDescription: "Calidad, personalización y certificación garantizan la excelencia en cada servicio."
    },
    counters: [
      {
        value: 50,
        suffix: "+",
        title: "Empresas beneficiadas",
        description: "Hemos acompañado su proceso de transformación corporativa."
      },
      {
        value: 10,
        title: "Años de experiencia",
        description: "Implementando soluciones de bienestar laboral."
      }
    ]
  },  
  "opositores": {
    sidebarLinks: [
      { href: "/otros-servicios/servicios-a-empresas", label: "Servicio a Empresas" },
      { href: "/otros-servicios/opositores", label: "Opositores" , active: true },
      { href: "/otros-servicios/corredores", label: "Corredores"},
      { href: "/otros-servicios/aumento-masa-muscular", label: "Aumento de masa muscular"},
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Archivo PDF con más información",
      link: "",
    },
    bannerData: {
      titleLine1: "Llama a nuestros asesores para",
      highlightText: "consulta gratuita",
      titleLine2: "en preparación integral",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "Contáctanos en WhatsApp",
      buttonLink: "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con&type=phone_number&app_absent=0",
    },
    featuredImage: "/assets/images/services/opositores.jpeg",
    introText:
      "Para quienes se preparan para oposiciones, ofrecemos estrategias de nutrición, planificación y manejo del estrés que te ayudarán a rendir al máximo.",
    specializationTitle: "Plan de Apoyo para Opositores",
    specializationText:
      "Optimiza tus horas de estudio y potencia tu concentración con un programa creado específicamente para las exigencias de la oposición.",
    leftColumnImage: "/assets/images/single-img-5.png",
    rightColumnContent: {
      title: "Rendimiento Óptimo",
      descriptionBefore: "Asegura tu salud y bienestar a través de",
      highlightText: "una alimentación equilibrada",
      descriptionAfter:
        "y técnicas de control de la ansiedad que te permitan mantenerte enfocado.",
      list1: ["Menús ricos en micronutrientes para estudiar", "Estrategias de descanso y recuperación"],
      list2: ["Mejorar la composición corporal", "Seguimiento semanal"],
      subTitle: "Lo que obtendrás con nuestro servicio para opositores",
      subDescription:
        "Una preparación integral que incluye pautas de alimentación, soporte psicológico y planificaciones efectivas para alcanzar tu plaza.",
    },
    counters: [
      {
        value: 120,
        suffix: "+",
        title: "Opositores guiados",
        description: "Han mejorado su rendimiento y obtenido buenos resultados.",
      },
      {
        value: 8,
        title: "Años de experiencia",
        description: "Trabajando con futuros funcionarios y profesionales.",
      }
    ]
  },
  "corredores": {
    sidebarLinks: [
      { href: "/otros-servicios/servicios-a-empresas", label: "Servicio a Empresas" },
      { href: "/otros-servicios/opositores", label: "Opositores" },
      { href: "/otros-servicios/corredores", label: "Corredores", active: true },
      { href: "/otros-servicios/aumento-masa-muscular", label: "Aumento de masa muscular"},
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Archivo PDF con más información",
      link: "",
    },
    bannerData: {
      titleLine1: "Llama a nuestros asesores para",
      highlightText: "consulta gratuita",
      titleLine2: "en alto rendimiento",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "Contáctanos en WhatsApp",
      buttonLink: "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con&type=phone_number&app_absent=0",
    },
    featuredImage: "/assets/images/services/corredores.jpeg",
    introText:
      "Si eres un corredor profesional o aspiras a serlo, te ofrecemos planes de nutrición y entrenamiento diseñados para maximizar tu resistencia y tu velocidad.",
    specializationTitle: "Programa para Corredores",
    specializationText:
      "Acompañamos tu trayectoria deportiva con consejos para la carga de hidratos, recuperación muscular y prevención de lesiones.",
      leftColumnImage: "/assets/images/single-img-5.png",
      rightColumnContent: {
      title: "Vence tus Próximas Metas",
      descriptionBefore: "Fortalece tu cuerpo y tu mente con",
      highlightText: "un plan de alimentación adaptado",
      descriptionAfter: "que respalda cada etapa de tu entrenamiento y competiciones.",
      list1: ["Alimentación adaptada a la recuperación y rendimiento", "Suplementos enfocados en el rendimiento"],
      list2: ["Técnicas de carga y descarga", "Seguimiento Semanal"],
      subTitle: "Lo que obtendrás con nuestro programa para corredores",
      subDescription:
        "Rendimiento deportivo mejorado, mayor resistencia y un acompañamiento integral que te ayude a alcanzar tus objetivos.",
    },
    counters: [
      {
        value: 70,
        suffix: "+",
        title: "Corredores",
        description: "Han optimizado su rendimiento con nuestras recomendaciones.",
      },
      {
        value: 4,
        title: "Especialistas deportivos",
        description: "Dedicados a la nutrición y la salud de corredores",
      },
    ],
  },
  "aumento-masa-muscular": {
    sidebarLinks: [
      { href: "/otros-servicios/servicios-a-empresas", label: "Servicio a Empresas" },
      { href: "/otros-servicios/opositores", label: "Opositores" },
      { href: "/otros-servicios/corredores", label: "Corredores"},
      { href: "/otros-servicios/aumento-masa-muscular", label: "Aumento de masa muscular", active: true },
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Archivo PDF con más información",
      link: "",
    },
    bannerData: {
      titleLine1: "Llama a nuestros asesores para",
      highlightText: "consulta gratuita",
      titleLine2: "en nutrición",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "Contáctanos en WhatsApp",
      buttonLink:
        "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con&type=phone_number&app_absent=0",
    },
    // Tailored content for "aumento de masa muscular"
    featuredImage: "/assets/images/bg-image/row-bgimage-4.jpg",
    introText:
      "Si tu objetivo es ganar músculo y fuerza, nuestro equipo de nutricionistas te guiará en la ingesta de proteínas y calorías de forma personalizada.",
    specializationTitle: "Nutrición para Ganar masa muscular",
    specializationText:
      "Combina rutinas de entrenamiento enfocadas y una alimentación rica en nutrientes para lograr el aumento muscular que buscas.",
    leftColumnImage: "/assets/images/bg-image/col-bgimage-3.png",
    rightColumnContent: {
      title: "Desarrolla tu Potencial",
      descriptionBefore: "Maximiza tu rendimiento deportivo con",
      highlightText: "una dieta rica en proteínas",
      descriptionAfter:
        "y micronutrientes que favorecen la construcción de masa muscular.",
      list1: ["Planes hipercalóricos de calidad", "Adaptación y progresión para evitar el estancamiento"],
      list2: ["Suplementación deportiva, en caso de ser necesaria", "Seguimiento semanal"],
      subTitle: "Lo que obtendrás con nuestro programa",
      subDescription:
        "Rutinas estructuradas, registro de progresos y un plan de alimentación específico para tu objetivo de masa muscular.",
    },
    counters: [
      {
        value: 60,
        suffix: "+",
        title: "Clientes guiados",
        description: "Lograron aumentar su rendimiento con nuestro método.",
      },
      {
        value: 25,
        title: "Años de experiencia",
        description: "Desarrollando planes eficientes para ganar masa muscular.",
      },
    ],
  },
  // Psicologia
  "sesiones-grupales": {
    sidebarLinks: [
      { href: "/psicologia/sesiones-grupales", label: "Sesiones grupales", active: true },
      { href: "/psicologia/adultos", label: "Psicología para adultos" },
      { href: "/psicologia/adolescentes", label: "Psicología para adolescentes" },
      { href: "/psicologia/deportistas", label: "Psicología para deportistas" }
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Sesiones Grupales PDF",
      link: ""
    },
    bannerData: {
      titleLine1: "Descubre nuestras",
      highlightText: "Sesiones Grupales",
      titleLine2: "para bienestar emocional",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "WhatsApp",
      buttonLink: "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con&type=phone_number&app_absent=0"
    },
    featuredImage: "/assets/images/services/psicologia/sesion-grupal.jpeg",
    introText:
      "Cada proceso es único, pero no excepcional. Compartimos miedos, dificultades, experiencias y oportunidades para aprender juntos en un espacio seguro sin juicios.",
    specializationTitle: "Talleres Temáticos Grupales",
    specializationText:
      "Talleres mensuales de 2 horas que abordan diversos temas clave durante procesos personales y familiares.",
    leftColumnImage: "/assets/images/services/psicologia/sesion-grupal2.jpeg",
    rightColumnContent: {
      title: "Temas Principales",
      descriptionBefore: "Explora temas cruciales como:",
      highlightText: "salud emocional y alimentación",
      descriptionAfter: "para fortalecer tu proceso.",
      list1: [
        "Ansiedad y alimentación",
        "Prevención de recaídas",
        "Craving alimentario ",
        "Tristeza, depresión y alimentación"
      ],
      list2: [
        "Motivación y adherencia al proceso",
        "Apoyo familiar",
        "Imagen corporal y autoestima",
        "Talleres para adolescentes"
      ],
      subTitle: "Beneficios de participar",
      subDescription:
        "Comparte vivencias, recibe apoyo emocional y adquiere herramientas prácticas para tu bienestar y equilibrio."
    },
    counters: [
      {
        value: 100,
        suffix: "+",
        title: "Participantes satisfechos",
        description: "Han mejorado su bienestar emocional con nuestras sesiones."
      },
      {
        value: 12,
        title: "Talleres anuales",
        description: "Abordando diferentes áreas esenciales cada mes."
      }
    ]
  },
  "adultos": {
    sidebarLinks: [
      { href: "/psicologia/sesiones-grupales", label: "Sesiones grupales"},
      { href: "/psicologia/adultos", label: "Para adultos", active: true },
      { href: "/psicologia/adolescentes", label: "Para adolescentes" },
      { href: "/psicologia/deportistas", label: "Para Deportistas" }
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Archivo PDF con más información",
      link: ""
    },
    bannerData: {
      titleLine1: "Primera consulta",
      highlightText: "valoración psicológica",
      titleLine2: "y plan personalizado",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "WhatsApp",
      buttonLink: "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con&type=phone_number&app_absent=0"
    },
    featuredImage: "/assets/images/services/psicologia/adultos.jpeg",
    introText:
      "Consulta inicial completa para identificar problemas clave y definir tratamiento personalizado, con seguimiento semanal o quincenal.",
    specializationTitle: "¿En qué podemos ayudarte?",
    specializationText: "Afronta diversas dificultades emocionales y personales.",
    leftColumnImage: "/assets/images/bg-image/col-bgimage-3.png",
    rightColumnContent: {
      title: "Áreas de Intervención",
      descriptionBefore: "Te apoyamos en la gestión de:",
      highlightText: "ansiedad, depresión, autoestima",
      descriptionAfter: "y otras situaciones vitales.",
      list1: ["Trastorno de ansiedad", "Trastorno de depresión", "Somatizaciones", "Trastorno obsesivo compulsivo", "Problemas de autoestima", "Gestión de crisis o etapas difíciles", "Trastornos de conducta alimentaria"],
      list2: ["Trastorno de la personalidad", "Autoestíma", "Enfermedades crónicas", "Duelo y Trauma", "Terapia de pareja", "Dolor crónico", "Trastornos sexuales", "Violencia de género"],
      subTitle: "Resultados del tratamiento",
      subDescription:
        "Mejor bienestar emocional, aumento de la autoestima y superación efectiva de dificultades personales."
    },
    counters: [
      {
        value: 200,
        suffix: "+",
        title: "Adultos atendidos",
        description: "Han mejorado su bienestar emocional en nuestro centro.",
      },
      {
        value: 15,
        title: "Años de experiencia",
        description: "Dedicados a la práctica de la psicología y la salud mental.",
      },
    ],
  },
  "adolescentes": {
    sidebarLinks: [
      { href: "/psicologia/sesiones-grupales", label: "Sesiones grupales" },
      { href: "/psicologia/adultos", label: "Para adultos" },
      { href: "/psicologia/adolescentes", label: "Para adolescentes", active: true },
      { href: "/psicologia/deportistas", label: "Para Deportistas" }
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Archivo PDF con más información",
      link: ""
    },
    bannerData: {
      titleLine1: "Primera consulta",
      highlightText: "valoración psicológica",
      titleLine2: "y acompañamiento juvenil",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "WhatsApp",
      buttonLink: "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con&type=phone_number&app_absent=0"
    },
    featuredImage: "/assets/images/services/psicologia/adolescentes.jpeg",
    introText:
      "Valoración psicológica completa para conocer al adolescente, definir un plan adaptado y acompañarlo en su desarrollo personal y social.",
    specializationTitle: "¿En qué podemos ayudarte?",
    specializationText: "Intervención psicológica especializada en jóvenes.",
    leftColumnImage: "/assets/images/services/psicologia/student.jpeg",
    rightColumnContent: {
      title: "Áreas de trabajo",
      descriptionBefore: "Apoyo profesional ante situaciones como:",
      highlightText: "bullying, autoestima, ansiedad",
      descriptionAfter: "y conflictos familiares o escolares.",
      list1: [
        "Trastornos de ansiedad y depresión",
        "Somatizaciones",
        "Trastorno obsesivo compulsivo",
        "Orientacion psicoeducativa",
        "Problemas de autoestima e imagen corporal",
        "Conductas alimentarias",
        "Dificultades familiares"
      ],
      list2: [
        "Trauma",
        "Violencia de género",
        "Acoso escolar (Bullying)",
        "Habilidades sociales",
        "Duelo y crisis",
        "Problemas familiares",
        "Hhabilidades personales y sociales",
        "Herramientas para el desarrollo personal y social",
        "Orientación vocacional"
      ],
      subTitle: "Resultados esperados",
      subDescription:
        "Mayor autonomía, resiliencia, equilibrio emocional y desarrollo de una identidad sólida."
    },
    counters: [
      {
        value: 300,
        suffix: "+",
        title: "Adolescentes orientados",
        description: "Han adquirido herramientas para una transición estable a la adultez.",
      },
      {
        value: 10,
        title: "Especialistas enfocados",
        description: "En terapias y talleres para el desarrollo juvenil.",
      },
    ],
  },
  "deportistas": {
    sidebarLinks: [
      { href: "/psicologia/sesiones-grupales", label: "Sesiones grupales"},
      { href: "/psicologia/adultos", label: "Para adultos" },
      { href: "/psicologia/adolescentes", label: "Para adolescentes" },
      { href: "/psicologia/deportistas", label: "Para Deportistas", active: true },
    ],
    downloadBrochure: {
      image: "/assets/images/pdf-icon.png",
      alt: "Icono para descargar folleto",
      title: "Descargar folleto",
      subtitle: "Archivo PDF con más información",
      link: "",
    },
    bannerData: {
      titleLine1: "Llama a nuestros asesores para",
      highlightText: "consulta gratuita",
      titleLine2: "en psicología",
      icon: "/assets/images/call-icon.png",
      phone: "+34 621 234 462",
      email: "info@equipomag.com",
      buttonText: "WhatsApp",
      buttonLink: "https://api.whatsapp.com/send/?phone=34621234462&text=Hola%2C+me+gustar%C3%ADa+poder+hablar+con&type=phone_number&app_absent=0"
    },
    featuredImage: "/assets/images/bg-image/row-bgimage-4.jpg",
    introText:
      "Maximiza tu rendimiento deportivo a través de técnicas de concentración, manejo de estrés y motivación. Nuestros psicólogos especializados te ayudarán a alcanzar tu mejor versión.",
    specializationTitle: "Psicología Deportiva",
    specializationText:
      "Mejora tu resistencia mental y tu capacidad de superar obstáculos, tanto en entrenamientos como en competencias.",
    leftColumnImage: "/assets/images/services/psicologia/deportistas.jpeg",
    rightColumnContent: {
      title: "Domina tu Mente en el Deporte",
      descriptionBefore: "Fortalece tu autoconfianza y toma el control de",
      highlightText: "tus emociones bajo presión",
      descriptionAfter: "para rendir al máximo nivel.",
      list1: [
        "Plan de mentalidad ganadora",
        "Gestión emocional de la competición y posterior a la misma",
        "Ansiedad pre-competitiva",
        "Prevención y manejo del estrés", 
        "Liderazgo", 
        "Gestión de la presión"
      ],
      list2: [
        "Trabajo en equipo y gestión de grupos",
        "Parentalidad positiva relacionada con el deporte",
        "Problemas de confianza y motivación",
        "Lesiones deportivas y dolor"
      ],
      subTitle: "Lo que obtendrás con nuestro programa para deportistas",
      subDescription:
        "Una mejora en tu autoconciencia deportiva, concentración y estabilidad emocional que se traducen en logros y victorias. Conocer la relación entre la persona y la disciplina deportiva en cuestión, para mejorar el rendimiento y potenciar el bienestar y el disfrute de esta. Se trata de entrenar habilidades psicológicas adaptadas tanto al tipo de deporte como a la persona. Esta especialización de la psicología está diseñada para dar respuesta a todas las necesidades de cualquier deportista, entrenador o familia, sin importar la edad, categoría o nivel deportivo",
    },
    counters: [
      {
        value: 200,
        suffix: "+",
        title: "Clientes guiados",
        description: "Han mejorado su rendimiento con nuestro método.",
      },
      {
        value: 8,
        title: "Años de experiencia",
        description: "Trabajando con deportistas de alto rendimiento y amateurs.",
      },
    ],
  },
};

export default servicesData;
